import React from "react";
import { TermsStatus } from "../../adapters/insights-agent/state/AppState.ts";
import { LoadingDots } from "../../ui-library/LoadingDots/LoadingDots.tsx";
import { TermsAndConditionsModal } from "./TermsAndConditionsModal";

export interface TermsAndConditionsGuardProps {
  children: React.ReactNode;
  enableTermsAndConditions: boolean;
  termsStatus: TermsStatus;
  termsContent: string | null;
  isLoadingTerms: boolean;
  error: string | null;
  isAccepting: boolean;
  onAcceptTerms: () => void;
}

export const TermsAndConditionsGuard: React.FC<
  TermsAndConditionsGuardProps
> = ({
  children,
  enableTermsAndConditions,
  termsStatus,
  termsContent,
  isLoadingTerms,
  error,
  isAccepting,
  onAcceptTerms,
}) => {
  if (
    enableTermsAndConditions &&
    (termsStatus === "pending_acceptance" || termsStatus === "error")
  ) {
    return (
      <TermsAndConditionsModal
        open={true}
        onAccept={onAcceptTerms}
        onClose={() => {}}
        loading={isAccepting}
        termsContent={termsContent}
        isLoadingTerms={isLoadingTerms}
        error={error}
      />
    );
  }
  if (enableTermsAndConditions && termsStatus === "loading") {
    return (
      <>
        Loading
        <LoadingDots />
      </>
    );
  }

  return <>{children}</>;
};
